import * as TYPES from './audit-actiontypes';

const initialState = {
  auditState: null,
  auditType: null,
  patientId: null,
};

export const auditReducer = (state = initialState, action) => {
  let newState;

  switch (action.type) {
    case TYPES.AUDIT_REQUEST:
      newState = { ...action.state };
      break;
    case TYPES.AUDIT_SUCCESS:
      newState = { ...action.state };
      break;
    case TYPES.AUDIT_FAILURE:
      newState = { ...action.state };
      break;
    default:
      newState = state;
  }

  return newState;
};

export default auditReducer;
